import axios from "axios";

/* Disable browser caching */
axios.defaults.headers.get["If-Modified-Since"] = new Date(0).toUTCString();
axios.defaults.headers.common["Vixly-Language"] = document.documentElement.lang;

axios.interceptors.response.use(null, (error) =>
{
	if (error.response && error.response.data && error.response.data.error)
		error.message = error.response.data.error.message;

	if (error.response && error.response.status === 401)
		return $vixLogin().then(() => axios.request(error.config), () => Promise.reject(error));

	return Promise.reject(error);
});


export default class Http
{
	constructor(data = null)
	{
		this.data  = data;
		this.error = null;
		this.busy  = false;
		this._seq  = 0;
	}


	request(config, success = () => null, failure = () => null)
	{
		const seq = ++this._seq;

		const p = axios.request(config).then((resp) =>
		{
			if (seq >= this._seq) {
				this.data = resp.data;
				this.busy = false;
				success(resp);
			}

			return resp;
		});

		p.catch((error) =>
		{
			if (seq >= this._seq) {
				this.error = error.message;
				this.busy = false;
				Http.failure(error);
				failure(error);
			}
		});

		this.error = null;
		this.busy = true;

		return p;
	}


	get(url, success, failure)
	{
		return this.request({ method: "get", url }, success, failure);
	}


	delete(url, success, failure)
	{
		return this.request({ method: "delete", url }, success, failure);
	}


	post(url, data, success, failure)
	{
		return this.request({ method: "post", url, data }, success, failure);
	}


	patch(url, data, success, failure)
	{
		return this.request({ method: "patch", url, data }, success, failure);
	}
}

Http.failure = () => null;
